import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./wedding.css";
import TemplateV1 from "./pages/TemplateV1";
import WeddingV1 from "./pages/WeddingV1";
import WeddingV2 from "./pages/WeddingV2";
import WeddingV3 from "./pages/WeddingV3";
import WeddingDashboard from "./pages/admin/WeddingDashboard";
import WeddingEdit from "./pages/admin/WeddingEdit";
import WeddingUndangan from "./pages/admin/WeddingUndangan";
import WeddingCreate from "./pages/admin/WeddingCreate";
import WeddingLogin from "./pages/admin/WeddingLogin";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          {/* <Header /> */}
          <Switch>
            <Route exact path="/v1" component={TemplateV1} />
            <Route
              exact
              path="/admin-wedding/index"
              component={WeddingDashboard}
            />
            <Route path="/wedv1/:username/:permalink" component={WeddingV1} />
            <Route path="/wedv1/:username" component={WeddingV1} />
            <Route path="/wedv2/:username/:permalink" component={WeddingV2} />
            <Route path="/wedv2/:username" component={WeddingV2} />
            <Route path="/wedv3/:username/:permalink" component={WeddingV3} />
            <Route path="/wedv3/:username" component={WeddingV3} />
            <Route
              path="/admin-wedding/edit/:username"
              component={WeddingEdit}
            />
            <Route
              path="/admin-wedding/undangan/:username"
              component={WeddingUndangan}
            />
            <Route
              exact
              path="/admin-wedding/create"
              component={WeddingCreate}
            />
            <Route exact path="/admin-wedding/login" component={WeddingLogin} />
          </Switch>
          {/* <Footer /> */}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
